import React, { useState } from 'react'
import { Accordion, Card, Button } from 'react-bootstrap'

const Index = () => {

    const [activeTab, setActiveTab] = useState("0")

    return(
        <div className="tab-section-container">
            <div className="inner-tab-section-container">
                <p className="introduction-text">
                    Pipeline lar deg få et bedre overblikk og hjelper deg med å visualisere hvor du befinner deg i de ulike salgsprosessene. Du kan lettere danne deg et bilde av hvor nærme du er en avtale, og på den måten delegere tiden din deretter basert på fremtidig potensiell avkastning. Det er også en ypperlig måte å finne avvik og ta opp igjen dialog.
                    <br/><br/>
                    Du kan opprette så mange pipelines du vil, da det ikke er noen maksgrense på dette. Det er typisk å opprette en pipeline enten for hvert produkt man ønsker å selge, og dele opp stegene forskjellig. Du kan fjerne, legge til og justere steg i en pipeline slik du måtte ønske - som gjør det til et fleksibelt og brukervennlig verktøy.
                </p>
                <div className="accordion-container">
                <Accordion className="company-accordion" defaultActiveKey="0" activeKey={activeTab}>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="0" onClick={() => setActiveTab("0")}>
							<button className={`collapse-button ${activeTab === "0" ? "active":""}`}>{activeTab === "0" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Opprett en ny pipeline
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="0">
						<Card.Body className="card-body">
                            <p className="description-text">Når du oppretter et nytt arbeidsmiljø vil du automatisk få en standard pipeline. I mange tilfeller har man behov for flere, og slik går du frem for å opprette en ny pipeline:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Pipeline"</span> fra menyen til venstre.</li>
								<li>Trykk på <span className="bold">"Min pipeline"</span>-knappen og velg <span className="bold">"Ny pipeline"</span> fra menyen.</li>
								<li>Skriv deretter inn ønsket navn på pipeline.</li>
								<li>Skriv inn navnet på fasen og trykk <span className="bold">"Legg til"</span> i feltet under.</li>
								<li>Repeter dette for hver fase du ønsker å legge til.</li>
								<li>Trykk til slutt på <span className="bold">"Opprett ny"</span>-knappen.</li>
							</ol>
							<p className="description-text">Dersom du tidligere har endret navnet på standard pipeline med navn <span className="bold">"Min pipeline"</span>, vil det istedenfor stå navnet på det du endret navnet til. Denne knappen viser navnet på aktiv pipeline, og kan derfor variere.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="1" onClick={() => setActiveTab("1")}>
                            <button className={`collapse-button ${activeTab === "1" ? "active":""}`}>{activeTab === "1" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Endre pipeline
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="1">
						<Card.Body className="card-body">
                            <p className="description-text">Endring av pipeline er veldig enkelt, og slik gjør du det:</p>
							<ol className="description-list">
								<li>Velg først pipeline du ønsker å endre fra knappen hvor aktiv pipeline vises.</li>
								<li>Trykk på <span className="bold">"Innstillinger"</span>-knappen øverst.</li>
								<li>Gjør deretter endringene du ønsker.</li>
								<li>Trykk til slutt på <span className="bold">"Oppdater"</span>-knappen.</li>
							</ol>
							<p className="description-text">Gjennom innstillinger kan du også blant annet endre på rekkefølgen til de forskjellige fasene, og det gjør du ved å trykke og dra fasen du vil endre plass på til et annet sted i visningen.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="2" onClick={() => setActiveTab("2")}>
                            <button className={`collapse-button ${activeTab === "2" ? "active":""}`}>{activeTab === "2" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Slett pipeline
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="2">
						<Card.Body className="card-body">
                            <p className="description-text">For å slette en pipeline gjør du følgende:</p>
							<ol className="description-list">
								<li>Velg først pipeline du ønsker å endre fra knappen hvor aktiv pipeline vises.</li>
								<li>Trykk på <span className="bold">"Innstillinger"</span>-knappen øverst.</li>
								<li>Deretter trykker du på <span className="bold">"Slett pipeline"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
				    <Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="3" onClick={() => setActiveTab("3")}>
                            <button className={`collapse-button ${activeTab === "3" ? "active":""}`}>{activeTab === "3" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til en mulighet
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="3">
						<Card.Body className="card-body">
                            <p className="description-text">Prosessen ved å legge til en ny mulighet i en pipeline er enkel, og slik gjør du det:</p>
							<ol className="description-list">
								<li>Trykk på <span className="bold">"Ny mulighet"</span>-knappen øverst til høyre.</li>
								<li>Velg deretter kundetype og fyll inn nødvendige detaljer.</li>
								<li>Trykk til slutt på <span className="bold">"Legg til"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="4" onClick={() => setActiveTab("4")}>
                            <button className={`collapse-button ${activeTab === "4" ? "active":""}`}>{activeTab === "4" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Flytte en mulighet
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="4">
						<Card.Body className="card-body">
                            <p className="description-text">Slik går du frem for å flytte en mulighet:</p>
							<ol className="description-list">
								<li>Velg først pipeline der muligheten befinner seg.</li>
								<li>Trykk på muligheten du ønsker og flytte og hold musepekeren nede.</li>
								<li>Dra så muligheten over til fasen du ønsker å flytte den til.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="5" onClick={() => setActiveTab("5")}>
                            <button className={`collapse-button ${activeTab === "5" ? "active":""}`}>{activeTab === "5" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Endre en mulighet
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="5">
						<Card.Body className="card-body">
                            <p className="description-text">For å endre en mulighet, gjør følgende:</p>
							<ol className="description-list">
								<li>Velg først pipeline der muligheten befinner seg.</li>
								<li>Trykk på penn-ikonet øverst til høyre i boksen på muligheten.</li>
								<li>Gjør så endringene du ønsker.</li>
								<li>Trykk til slutt på <span className="bold">"Oppdater"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card last">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="6" onClick={() => setActiveTab("6")}>
                            <button className={`collapse-button ${activeTab === "6" ? "active":""}`}>{activeTab === "6" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Slett en mulighet
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="6">
						<Card.Body className="card-body">
                            <p className="description-text">Sletting av en mulighet er veldig enkelt, og slik gjør du det:</p>
							<ol className="description-list">
								<li>Velg først pipeline der muligheten befinner seg.</li>
								<li>Trykk på søppeldunk-ikonet øverst til høyre i boksen på muligheten.</li>
								<li>Bekreft sletting ved å trykke på <span className="bold">"Ja, slett mulighet"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
			</Accordion>
                </div>
            </div>
        </div>
    )
}

export default Index